import React from 'react'

import { connect } from 'react-redux'
import { faFlaskGear } from '@fortawesome/pro-solid-svg-icons'

import { ColorsPalette } from '../../config/colors'
import TooltipIcon from '../icons/TooltipIcon'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const mapStateToProps = state => ({ t: selectTranslate(state) })

const ExperimentalTitle = ({ title, t }) => {
  return (
    <div className='experimental-title'>
      <TooltipIcon title={t('experimental_icon.title')} icon={faFlaskGear} color={ColorsPalette.BLUE_ICON} />
      &nbsp;
      {t(title)}
    </div>
  )
}

export default connect(mapStateToProps)(ExperimentalTitle)
